import React from "react";

const NotFound: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
        </div>
    );
};

export default NotFound;
